import { styled } from '@mui/material/styles';
import LinearProgress from '@mui/material/LinearProgress';
import useDebounce from 'hooks/useDebounce';
import Logo from 'logos/Logo';
import { CurrentUser } from 'auth';

const Root = styled('div')(() => ({
  position: 'fixed',
  width: '100vw',
  height: '100vh',
  background: 'white',
  zIndex: 10000,
  '& .splash-logo': {
    left: '50%',
    top: '50%',
    marginLeft: -180,
    marginTop: -100,
    position: 'absolute',
    '& > *': {
      marginBottom: 15,
    },
  },
}));

interface Props {
  name?: 'atlas' | 'coriolis';
  hide: boolean;
  debounce: number; // mill sec
}

export default function Splash(props: Props): JSX.Element {
  const { hide, debounce = 750 } = props;
  const logUrl = CurrentUser.getInstance().getOrganisationAttr('logoUrl');
  const debouncedHide = useDebounce(hide, debounce);
  if (debouncedHide) {
    return <></>;
  }
  return (
    <Root className="splash-screen">
      <div className="splash-logo">
        <Logo src={logUrl} height={150} name="coriolis" />
        <LinearProgress color="inherit" />
      </div>
    </Root>
  );
}
